import React, { createContext, useState, useContext } from "react";

const SequenceAlarmContext = createContext();

export const SequenceAlarmProvider = ({ children }) => {
  const [isSequenceAlarmPlaying, setIsSequenceAlarmPlaying] = useState(false);

  const contextValue = React.useMemo(
    () => ({ isSequenceAlarmPlaying, setIsSequenceAlarmPlaying }),
    [isSequenceAlarmPlaying]
  );

  return (
    <SequenceAlarmContext.Provider value={contextValue}>
      {children}
    </SequenceAlarmContext.Provider>
  );
};

export const useSequenceAlarm = () => useContext(SequenceAlarmContext);

